import React, { useState, useEffect, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { GoogleMap, LoadScript, Polyline, Marker, InfoWindow } from "@react-google-maps/api";
import API from '../../services/api-service';
import { Main, ContenedorFechas } from '../Historico/ElementosStyles';
import { Button } from "react-bootstrap";

const TrackPosition = () => {
    const query = new URLSearchParams(useLocation().search);
    const deviceID = query.get("deviceID");
    const history = useHistory();
    const [apiLoaded, setApiLoaded] = useState(false);
    const [rutaVehiculo, setRutaVehiculo] = useState([]);
    const [selectedPoint, setSelectedPoint] = useState(null);
    const center = rutaVehiculo[0] || { lat: 0, lng: 0 };

    const getData = useCallback(() => {
        const devices = [deviceID];
        API.getTrackerPosition(devices).then((response) => {
            const transformedArray = response.data.map(({ latitude, longitude, ...rest }) => ({
                ...rest,
                lat: latitude,
                lng: longitude
            }));
            setRutaVehiculo(transformedArray);
            setSelectedPoint(null);
        }).catch((error) => {
            console.log(error);
        });
    }, [deviceID]);

    useEffect(() => {
        getData();
        const intervalId = setInterval(getData, 10000);
        return () => clearInterval(intervalId);
    }, [getData]);

    return (
        <>
            <Main>
                <ContenedorFechas>
                    <Button onClick={() => { history.goBack() }}>Atras</Button>
                </ContenedorFechas>
            </Main>
            <Main>
                {rutaVehiculo.length == 1 ? <>
                    <p><b>ID:</b> {rutaVehiculo[0].deviceId}</p>
                    <p><b>Fecha:</b> {new Date(rutaVehiculo[0].fechaCompleta).toLocaleString('es-ES', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        timeZone: 'UTC'
                    })}</p>
                    <p><b>Velocidad:</b> {rutaVehiculo[0].speed || 'N/A'} km/h</p>
                    <p><b>Estado:</b> {rutaVehiculo[0].ACC ? 'Encendido' : 'Apagado'}</p>
                    <p><b>Batería:</b> {rutaVehiculo[0].batteryVoltage}</p>
                </> : null}

                <LoadScript googleMapsApiKey="AIzaSyBYNDUEf0g8OQPJfiEW7ybizYPiMN_7XOU" onLoad={() => setApiLoaded(true)}>
                    <GoogleMap mapContainerStyle={{ height: "500px", width: "100%" }} zoom={15} center={center}>
                        {apiLoaded && rutaVehiculo.map((p, index) => {
                            let circleColor = { backgroundColor: "#0000FF", borderColor: "#000066" };
                            if (p.ACC) {
                                circleColor = { backgroundColor: "#00FF00", borderColor: "#006600" };
                                if (p.speed >= 100) {
                                    circleColor = { backgroundColor: "#FF0000", borderColor: "#660000" };
                                }
                            }
                            const circleSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <circle 
                                cx="12" 
                                cy="12" 
                                r="10" 
                                fill="${circleColor.backgroundColor}" 
                                stroke="${circleColor.borderColor}" 
                                stroke-width="3"
                                />
                            </svg>`;
                            return (
                                <React.Fragment key={index}>
                                    <Marker
                                        position={p}
                                        onClick={() => setSelectedPoint(p)}
                                        icon={{
                                            url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(circleSvg)}`,
                                            scaledSize: new window.google.maps.Size(15, 15),
                                        }}
                                    />
                                    {selectedPoint && selectedPoint._id === p._id && (
                                        <InfoWindow
                                            position={p}
                                            onCloseClick={() => setSelectedPoint(null)}
                                        >
                                            <div style={{ padding: '5px' }}>
                                                <p><b>ID:</b> {p.deviceId}</p>
                                                <p><b>Fecha:</b> {new Date(p.fechaCompleta).toLocaleString('es-ES', {
                                                    weekday: 'long',
                                                    year: 'numeric',
                                                    month: 'long',
                                                    day: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                    timeZone: 'UTC'
                                                })}</p>
                                                <p><b>Velocidad:</b> {p.speed || 'N/A'} km/h</p>
                                                <p><b>Estado:</b> {p.ACC ? 'Encendido' : 'Apagado'}</p>
                                                <p><b>GPS:</b> {p.GPS ? 'Conectado' : 'Desconectado'}</p>
                                                <p><b>Coordenadas:</b> {p.lat.toFixed(6)}, {p.lng.toFixed(6)}</p>
                                                <p><b>Batería:</b> {p.batteryVoltage}</p>
                                                <p><b>Intensidad de la señal:</b> {p.networkSignalStrength}</p>
                                                <p><b>Kilometraje:</b> {p.mileage}</p>
                                                <p><b>Altitud:</b> {p.altitude}</p>
                                            </div>
                                        </InfoWindow>
                                    )}
                                </React.Fragment>
                            )
                        })}
                    </GoogleMap>
                </LoadScript>
            </Main>
        </>
    );
};

export default TrackPosition;